import jwtClient from "@/services/axios/jwt"
import store from "store"

// const self = this

export async function login(email, password) {
//   const self = this
  return jwtClient
    .post("/auth/login",
      {
        email,
        password,
      })
    .then((response) => {
      console.log(response)
      const status = JSON.parse(response.status)
      if (status === 200) {
        const accessToken = response.data.access_token
        if (accessToken) {
          store.set("accessToken", accessToken)
        }
        return true
        // next()
        // this.$router.push(this.$route.query.redirect || "/")
        // return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function register(email, password, name) {
  return jwtClient
    .post("/auth/register", {
      email,
      password,
      name,
    })
    .then(response => {
      if (response) {
        const { accessToken } = response.data
        if (accessToken) {
          store.set("accessToken", accessToken)
        }
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function currentAccount() {
  return jwtClient
    .get("/auth/account")
    .then(response => {
      if (response) {
        const { accessToken } = response.data
        if (accessToken) {
          store.set("accessToken", accessToken)
        }
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function logout() {
  return jwtClient
    .post("/auth/logout")
    .then(() => {
      store.remove("accessToken")
      return true
    })
    .catch(err => console.log(err))
}
